import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = ['Instant Digital Access', 'Secure Checkout', 'Ready-to-Use Resources'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-100" data-mp="12mr4ded6pcad">
      <div className="mx-auto max-w-4xl text-center" data-id="element-101" data-mp="1zcqmo0j4zp65">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-102" data-mp="1zbffdqqhfzaa">
          For Barber Instructors & Educators
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-103" data-mp="1lbnwpcp0tupy">
          Plan Your Barbering Classes in <Accent data-id="element-104" data-mp="9w91oegdhcxh">Minutes</Accent> — Not Hours.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-105" data-mp="38gbhcr0hte5g">
          Stop starting every lesson from scratch.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-106" data-mp="3dd1x1d8dy7qc">
          A complete ready-to-teach system for fades, classic cuts, beard work and classroom
          management — made for professionals who teach barbering.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Barber Instructor Ready — six teaching volumes shown on spiral books, tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(20, 40, 59, 0.18))'
    }} data-id="element-107" data-mp="2pnqv3sfau7am" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-108" data-mp="2bq2gv3fqlyej">
        <strong className="font-semibold text-brand-charcoal" data-id="element-109" data-mp="ha3t7t6u3mhh">6 complete volumes + 5 teaching bonuses</strong>{' '}
        with structured lessons, haircutting and fade references, hands-on worksheets, skill
        assessments and classroom tools — so you spend less time preparing and more time teaching.
      </p>

      <CtaBlock label="Get Instant Access" className="mt-9" data-id="element-110" data-mp="3jib46p7fgkn" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-111" data-mp="108g4bkhb36fp">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-112" data-mp="w6uvca7w7cas">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-113" data-mp="r6yn1ys5wypf" />
            {item}
          </li>)}
      </ul>
    </section>;
}